import type { ApolloClient } from '@apollo/client';
import type { Zone } from '@seek/audience-zones';
import type { Language } from '@seek/ca-myprofile-utils';

import { getDataFromCache } from 'src/modules/apollo/apolloCache';
import * as Schema from 'src/types/graphql';

export const generateUpdateProfileVisibilityOptimisticResponse =
  (_id: string) =>
  ({ profileVisibility }: Schema.UpdateProfileVisibilityMutationVariables) => ({
    __typename: 'Mutation',
    updateProfileVisibility: {
      __typename: 'UpdateProfileVisibilityPayload',
      viewer: {
        __typename: 'Candidate',
        _id,
        profileVisibility: {
          __typename: 'ProfileVisibility',
          level: profileVisibility.level,
        },
      },
    },
  });

export const generateUpdateShareableProfileSettingsOptimisticResponse =
  ({
    _id,
    apolloClient,
    languageCode,
    zone,
  }: {
    _id: string;
    apolloClient: ApolloClient<any>;
    languageCode: Language;
    zone: Zone;
  }) =>
  ({
    active,
  }: {
    active: Schema.UpdateShareableProfileSettingsInput['active'];
  }) => ({
    updateShareableProfileSettings: {
      __typename: 'UpdateShareableProfileSettingsSuccess',
      viewer: {
        __typename: 'Candidate',
        _id,
        shareableProfileSettings: {
          __typename: 'ShareableProfileSettings',
          profileSlug:
            getDataFromCache({
              cache: apolloClient.cache,
              query: Schema.GetShareableProfileSettingsDocument,
              variables: {
                zone,
                languageCode,
              },
            })?.viewer?.shareableProfileSettings?.profileSlug || null,
          url:
            getDataFromCache({
              cache: apolloClient.cache,
              query: Schema.GetShareableProfileSettingsDocument,
              variables: {
                zone,
                languageCode,
              },
            })?.viewer?.shareableProfileSettings?.url || null,
          displayUrl:
            getDataFromCache({
              cache: apolloClient.cache,
              query: Schema.GetShareableProfileSettingsDocument,
              variables: {
                zone,
                languageCode,
              },
            })?.viewer?.shareableProfileSettings?.displayUrl || null,
          active,
          views:
            getDataFromCache({
              cache: apolloClient.cache,
              query: Schema.GetShareableProfileSettingsDocument,
              variables: {
                zone,
                languageCode,
              },
            })?.viewer?.shareableProfileSettings?.views || null,
        },
      },
    },
  });
